<div class="app-content content">
    <div class="content-wrapper">
      <div class="content-header row mb-1">
      </div>
      <div class="content-body">
        <section id="horizontal-form-layouts">
          <div class="row justify-content-md-center">
            <div class="col-md-6">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title font-medium-3" id="horz-layout-card-center">Crear cuenta de administrador</h4>
                </div>
                <div class="card-content collpase show">
                  <div class="card-body">
                    <div class="card-text">
                      <p>Completa los campos del formulario para registrar a un nuevo administrador.</p>
                    </div>
                    <form class="form form-horizontal" [formGroup]="addAdminForm">
                      <div class="form-body">
                        <div class="form-group row mx-auto">
                          <label class="col-md-3 label-control" for="eventRegInput1">Nombre completo</label>
                          <div class="col-md-9">
                            <input type="text" id="eventInput1" class="form-control" placeholder="Lirio Salas Ruiz"
                              formControlName="name">
                          </div>
                        </div>
                        <div class="form-group row mx-auto">
                          <label class="col-md-3 label-control" for="eventRegInput2">Usuario (acceder al sistema)</label>
                          <div class="col-md-9">
                            <input type="text" id="eventInput2" class="form-control" placeholder="Admin5718"
                              formControlName="username">
                          </div>
                        </div>
                        <div class="form-group row mx-auto">
                          <label class="col-md-3 label-control" for="eventRegInput3">Contraseña</label>
                          <div class="col-md-9">
                            <input type="text" id="eventInput3" readonly [value]="addAdminForm.get('username').value" class="form-control" placeholder="*******">
                          </div>
                        </div>
                      </div>
                      <div class="form-actions text-center">
                        <button type="submit" [disabled]="addAdminForm.invalid" (click)="trySubmit()" class="btn btn-navy">
                          <i class="la la-check"></i> Crear cuenta
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div class="p-2 mt-2"></div>
        <div class="p-2 mt-2"></div>
      </div>
    </div>
  </div>
  